import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AsyncActionButton, reportErrorToConsole, useRetryHardHit } from '@applyonline/shared';
import { useTranslation } from 'react-i18next';
const RetryHardHitButton = ({ creditApp }) => {
    const { t } = useTranslation();
    const [retryHardHit, isSubmitting] = useRetryHardHit(creditApp.financingProgramId);
    return (_jsxs(AsyncActionButton, { fullWidth: true, primary: true, isPending: isSubmitting, type: "button", onClick: () => {
            retryHardHit(creditApp.id).catch(reportErrorToConsole);
        }, children: [_jsx("i", { className: "fa-solid fa-rotate-right" }), _jsx("span", { children: t('common.retryHardHit', { ns: 'shared' }) })] }));
};
export default RetryHardHitButton;
